<div class="table-skeleton">
  <div class="table-skeleton__content" *ngFor="let element of skeletonTableCount"></div>
</div>
